import React from 'react'

function QNA() {
    return (
        <div className='qna'>
            <div className='container'>
                <div className='HomeBox7-top'>
                    <h1>Questions & Answers</h1>
                    <p>Quick answers to common questions about Loyalific</p>
                </div>
                <div className='qna-main'>
                    <div className='qna-box'>
                        <h5><span>1.</span> Getting started with Loyalific?</h5>
                        <p>Getting started is simple: create an account, start a 15-day free trial, and design your first digital stamp card in the Loyalific dashboard. Add your logo, rewards and branding, then share your enrolment QR code so customers can add the card to Apple Wallet or Google Wallet.</p>
                    </div>
                    <div className='qna-box'>
                        <h5><span>2.</span> What's included in my account?</h5>
                        <p>Every account includes the card designer, customer and stamp tracking, QR codes and links for enrolment, Apple and Google Wallet support, basic reporting, and access to our support resources. Higher-tier plans unlock more card designs, locations, sub-users and advanced options.</p>
                    </div>
                    <div className='qna-box'>
                        <h5><span>3.</span> How do I choose a plan?</h5>
                        <p>Start by looking at how many locations you have and how many different card designs you need. Our lower-tier plans suit single-location businesses, while higher tiers are ideal if you run multiple venues or brands.</p>
                    </div>
                    <div className='qna-box'>
                        <h5><span>4.</span> How does Loyalific handle my privacy?</h5>
                        <p>We only collect the information needed to run your loyalty program and store it securely. Your customer data remains yours - we don' t sell it, and you control who can access it inside your account.</p>
                    </div>
                    <div className='qna-box'>
                        <h5><span>5.</span> I have an issue with my account?</h5>
                        <p>If something doesn't look right, you can contact us from inside the app or via the contact form on our website. Share as much detail as you can (screenshots help), and our support team will get back to you as quickly as possible.</p>
                    </div>
                    <div className='qna-box'>
                        <h5><span>6.</span> Can I cancel at anytime?</h5>
                        <p>Yes. You can cancel your subscription at any time from your billing settings. Your account will stay active until the end of your current billing period; we don't offer partial refunds for unused time. When you fully close your account, your projects and digital stamp cards are scheduled for deletion, so make sure you export any data you'd like to keep beforehand.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default QNA